import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import Feather from 'react-native-vector-icons/Feather';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const Content = styled.View`
  flex: 1;
  padding: 0 24px;
`;

export const OptionCard = styled.TouchableHighlight`
  border-radius: ${RFValue(12)}px;
  margin-bottom: ${RFValue(16)}px;
  overflow: hidden;
`;

export const OptionCardInner = styled.View`
  flex-direction: row;
  align-items: center;
  padding: ${RFValue(20)}px;
  border-radius: ${RFValue(12)}px;
  border-width: 2px;
  border-color: ${({theme}) => theme.colors.border};
  background-color: ${({theme}) => theme.colors.card || theme.colors.background};
`;

export const OptionIconWrapper = styled.View`
  width: ${RFValue(48)}px;
  height: ${RFValue(48)}px;
  border-radius: ${RFValue(24)}px;
  background-color: ${({theme}) => theme.colors.primary}20;
  justify-content: center;
  align-items: center;
  margin-right: ${RFValue(16)}px;
`;

export const OptionIcon = styled(MaterialCommunityIcons)`
  font-size: ${RFValue(24)}px;
  color: ${({theme}) => theme.colors.primary};
`;

export const OptionTextBlock = styled.View`
  flex: 1;
`;

export const OptionTitle = styled.Text`
  font-size: ${RFValue(16)}px;
  font-family: ${({theme}) => theme.fonts.bold};
  color: ${({theme}) => theme.colors.title};
  margin-bottom: ${RFValue(4)}px;
`;

export const OptionDescription = styled.Text`
  font-size: ${RFValue(13)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
`;

export const ChevronIcon = styled(Feather)`
  font-size: ${RFValue(20)}px;
  color: ${({theme}) => theme.colors.text};
`;

